import { injectReducer } from 'store/reducers'
import {
  UserIsAuthenticated,
  UserHasValidPassword,
  UserHasScope,
} from '../../../../../../../../containers/authContainers'
import users from './modules/Users'
import { getUserRoleIdByStudy } from '../../../../../../../../utils/misc'
import { USER_ROLE_IDS_WITH_LIMITED_SIDEBAR_ACCESS } from '../../../../../../../../utils/constants'
import { browserHistory } from 'utils/navigation'

// Sync route definition
export default store => ({
  exact: true,
  getComponent(nextState, cb) {
    require.ensure(
      [],
      require => {
        const { params } = nextState
        const { studyID, studyVersionID } = params

        const roleId = getUserRoleIdByStudy(store?.getState()?.user, studyID)
        if (USER_ROLE_IDS_WITH_LIMITED_SIDEBAR_ACCESS.includes(roleId)) {
          browserHistory.push(`/studies/${studyID}/${studyVersionID}/compliance`)
        }

        // Add Reducer
        injectReducer(store, {
          key: 'users',
          reducer: users,
        })

        store.dispatch(require('./modules/Users').actions.fetchUsers(Number(studyID)))
        // Return Component
        cb(
          null,
          UserIsAuthenticated(
            UserHasValidPassword(UserHasScope(['ru'], require('./containers/UserContainer').default, false, studyID)),
          ),
        )
      },
      'dashboard',
    )
  },
})
